import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import Model from '../model';

/**
 * Deal Model
 * @property {int} id
 * @property {CustomerModel} customer
 * @property {int} dealer_id
 * @property {Array.<DocumentRequestModel>} document_requests
 * @property {Array} documents
 * @property {Object} status
 * @property {Object} template
 * @property {Date} created_at
 * @property {Date} suppression_requested_at
 * @property __className
 */
export default class DealModel extends Model {
  /**
   * DealModel Constructor
   * @param deal
   */
  constructor(deal) {
    super(deal);
    // eslint-disable-next-line no-underscore-dangle
    this.__className = 'DealModel';
  }

  /**
   * Helper function for checking if a deal is open
   * @returns {boolean}
   */
  isOpen() {
    return this.status
            && this.status.name
            && this.status.name.toLowerCase() === 'open';
  }

  /**
   * Helper function for calculating the number of open document requests on a deal
   * @returns {Array}
   */
  openDocumentRequests() {
    return _.filter(
      this.document_requests,
      (request) => !request.is_complete && !request.is_rejected,
    );
  }

  documentsRequiringSignature() {
    return _.filter(
      this.documents,
      (document) => document.signature_is_required
        && document.template_document.signature_areas.length > 0,
    );
  }
}
